import { Box, Grid2, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import CompetitionResultCard from '../../shared/components/CompetitionResultCard'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Page_Padding } from '../../shared/constants'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';




const CompetitionResult = () => {
    const data = [
        {
            heading: "Eligibility",
            points: [
                {
                    text: "Open to children aged 5 to 13 years."
                },
                {
                    text: "Each participant may submit only one design."
                },
                {
                    text: "Designs must be created entirely by the child—no adult contributions allowed."
                },
            ]

        },
        {
            heading: "Design Guidelines",
            points: [
                {
                    text: "Artwork must be original and must not copy existing designs."
                },
                {
                    text: "Submissions must be made on the official T-shirt template"
                },
                {
                    text: "Acceptable mediums: hand-drawn (scanned), digital drawing, or mixed media."
                },
            ]

        }
    ]
    return (
        <Box className="body contact_us" px={Page_Padding}>
            <Typography variant='h4' textAlign={"center"}>Myskool Tshirt Design Contest 2025</Typography>
            <CustomDivider size={"2rem"} />
            <Typography variant='h5' my={1.5}>World oof Kindness & Positiviity</Typography>
            <Typography variant='body1' color='grey.600' fontWeight={200}>

                Myskool launched its first-ever T-Shirt design competition this year with the theme "A world of Kindness and Positivity".  Works by four young artists won the competition and are now part of Myskool’s capsule collection, Positivity Tees.From hundreds of apartment’s in banglore, we are pleased to announce the 4 winners.
            </Typography>
            <CustomDivider />
            <Grid2 container>
                {
                    [...Array(3)].map((item, index) => (
                        <Grid2 size={{xs:12,sm:12}} sx={{ m: "auto" }}>
                            <CompetitionResultCard />
                        </Grid2>
                    ))
                }
            </Grid2>
            <CustomDivider />
            <Typography variant='h4'>About the Contest</Typography>
            <CustomDivider size={"2rem"} />
            {
                data.map((item, index) => (
                    <Box key={index}>
                        <Typography variant="h6" mb={2}>{item?.heading}</Typography>
                        {
                            item?.points?.map((item, index) => (
                                <ListItem key={index} sx={{ alignItems: "flex-start"}}>
                                    <ListItemIcon sx={{ minWidth: "20px", mt: "8px" }}>
                                        <FiberManualRecordIcon sx={{ fontSize: 10, color: "red.main" }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Typography variant='body1' color='grey.600' fontWeight={200}>
                                                {item?.text}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                            ))
                        }
                        <CustomDivider size={"2rem"} />
                    </Box>
                ))
            }
        </Box>

    )
}

export default CompetitionResult
